import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { ApiHandlerService } from '../../../core/api-handlers';
import { FlightService } from '../flight.service';
import { TooltipConfig } from 'ngx-bootstrap/tooltip';
import { SubSink } from 'subsink';
import { AlertService } from '../../../core/services/alert.service';
import { UtilityService } from '../../../core/services/utility.service';
import { SwalService } from '../../../core/services/swal.service';
import { AppGlobal } from '../../../app.global';


export function getAlertConfig(): TooltipConfig {
    return Object.assign(new TooltipConfig(), {
        placement: 'right',
        container: 'body',
    });
}

@Component({
    selector: 'app-booking',
    templateUrl: './booking.component.html',
    styleUrls: ['./booking.component.scss'],
    providers: [{ provide: TooltipConfig, useFactory: getAlertConfig }],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BookingComponent implements OnInit, OnDestroy {
    terms: boolean = true;
    phoneCodes: Array<any> = [];
    primaryColour: any;
    secondaryColour: any;
    loadingTemplate: any;
    bsDateConf = {
        isAnimated: true,
        dateInputFormat: 'YYYY-MM-DD',
        containerClass: 'theme-blue',
        showWeekNumbers: false
    };

    isCollapsed = true;
    isCollapsedFareSumm = true;
    isCollapsedGst = true;
    isCollapsedServiceReqs = true;
    flight: any;
    flightString: any;
    traveller: any = false;
    travellerString: any;
    contactForm: FormGroup;
    usaDetailsForm: FormGroup;
    titles: any = [];
    infantsTitles: any = [];
    countries: any = [];
    loading: boolean;
    html = `<div class="container">
    <div class="row py-3">
        <div class="col-12 font-weight-bold">
            Information on Entry of Name(s)
        </div>
        <div class="col-12 mt-2">
            Name of the <mark>Passenger(s)</mark> must be identical with the name displayed on the selected ID type.
        </div>
        <div class="col-12">
            <div class="row col-12 bg my-2 mx-0 p-3">
                <div class="col-12 mb-3"> <span class="font-weight-bold f-14"> Passport </span> </div>
                <div class="col-3 pt-4">
                    <i class=" fa fa-5x fa-users"></i>
                </div>
                <div class="col-9">
                    <div class="d-flex flex-column">
                        <div class="text-muted">
                            <small> Last name </small> 
                        </div>
                        <div class="text-dark">
                            <span>
                                JONH
                            </span>
                        </div>
                        <div class="text-muted mt-3">
                            <small> First & middle name </small> 
                        </div>
                        <div class="text-dark">
                            <span>
                            STEVE  DOE
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 mt-3 f-12">
            <span class="font-italic f-14"> 
                N.B.- 
            </span>
            Passenger(s) who don't have first names may enter their last name in the boxese for both "last name" and "first & middle names".
        </div>
    </div>
</div>`;

    isConfirmed = false;
    maxDate = new Date();
    maxDateAdult: any;
    minDateAdult: any;
    maxDateChild: any;
    minDateChild: any;
    maxDateInfant: any;
    minDateInfant: any;
    extraServices = false;
    protected subs = new SubSink();
    
    constructor(
        private fb: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        private apiHandlerService: ApiHandlerService,
        private flightService: FlightService,
        private alertService: AlertService,
        private utility: UtilityService,
        private cdRef: ChangeDetectorRef,
        private swalService: SwalService,
        private globals: AppGlobal
    ) {
    }
    airline_logo: string = '';
    ngOnInit() {
        this.globals.showCurrencyConversion.next(false);
        this.getPhoneCodeList();
        this.getCountryList();
        this.getTitleList();
        this.airline_logo = this.flightService.airline_logo;
        this.subs.sink = this.flightService.extraServices.subscribe(res => {
            if (res) {
                this.extraServices = true;
            } else {
                this.extraServices = false;
            }
        });

        this.flightService.countryList.subscribe(res => {
            this.countries = res;
        });
        this.createContactForm();
        this.subs.sink = this.flightService.loading.subscribe(res => {
            this.loading = res;
        });
        this.subs.sink = this.flightService.bookingFlightData.subscribe(res => {
            if (typeof res == 'object' && res.JourneyList.hasOwnProperty('FlightDetails')) {
                this.flightService.extraFees.next(this.flightService.extraFees.value);
                this.traveller = this.flightService.traveller;
                this.flight = res.JourneyList;
                this.passengers.clear();
                let leadPax = 1;
                for (let t of Object.keys(this.traveller)) {
                    if (this.traveller[t]) {
                        for (let i = 0; i < this.traveller[t]; i++) {
                            this.addPassenger(t, i, leadPax);
                            leadPax = 0;
                        }
                    }
                }
                let airlineCodes = [];
                this.getFlightType(res.JourneyList);
            } else {
                this.router.navigate(['/']);
            }
            this.cdRef.detectChanges();
        });
        this.maxDateAdult = this.addYearsToDate(-12);
        this.minDateAdult = this.addYearsToDate(-100);
        this.maxDateChild = this.addYearsToDate(-2);
        this.minDateChild = this.addYearsToDate(-12);
        this.maxDateInfant = new Date();
        this.minDateInfant = this.addYearsToDate(-2);
    }


    getFlightType(flight) {
        let airlineCodes = [];
        if (flight && flight.FlightDetails) {
            flight.FlightDetails.Details.forEach(flightDetails => {
                flightDetails.forEach(flight => {
                    airlineCodes.push({
                        Destination: flight.Destination.AirportCode,
                        Origin: flight.Origin.AirportCode
                    });
                });
            });
            this.subs.sink = this.apiHandlerService.apiHandler('flightType', 'POST', '', '', {
                Segments: airlineCodes
            }).subscribe(resp => {
                this.flightService.flightType.next(resp.data);
            })
        }
    }

    onTerms(e) {
        console.log(e);
        this.terms = e

    }

    getPhoneCodeList() {
        this.subs.sink = this.apiHandlerService.apiHandler('phoneCodeList', 'POST')
            .subscribe(res => {
                console.log("in booking", res);
                if (res && res.data.length) {
                    this.phoneCodes = res.data;
                    this.cdRef.detectChanges();
                }
            });
    }

    getTitleList() {
        this.subs.sink = this.apiHandlerService.apiHandler('userTitlelist', 'POST')
            .subscribe(res => {
                if (res) {
                    this.titles = res.data;
                    this.infantsTitles = res.data.filter(t => t.titleId == 3 || t.titleId == 4);
                    this.cdRef.detectChanges();
                }
            });
    }

    getCountryList() {
        this.subs.sink = this.apiHandlerService.apiHandler('countryList', 'POST')
            .subscribe(res => {
                if (res && res.data.countries.length) {
                    this.countries = res.data.countries;
                    this.cdRef.detectChanges();
                    console.log(this.countries);

                }
            });
    }

    createContactForm() {
        this.contactForm = this.fb.group({
            passengers: this.fb.array([]),
            contact: this.fb.group({
                countryCode: ['BD', [Validators.required]],
                phoneAreaCode: '',
                phoneExtensionCode: '',
                phoneNumber: ['', [Validators.required]],
                email: ['', [Validators.required, Validators.email]],
                message: ['']
            }),
            usaForm: [0],
            usaDetailsForm: this.fb.group({
                country_name: ['USA'],
                gender: ['Male'],
                types: ['resident'],
                address: [''],
                city: [''],
                state: [''],
                postal_code: ['']
            }),
            baggageProtection: [false]
        });
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;

    }

    createUsaDetailsForm() {
        this.usaDetailsForm = this.fb.group({
            // passengers: this.fb.array([]),
            // contact: this.fb.group({
            //     countryCode: ['+91', [Validators.required]],
            //     phoneAreaCode: '080',
            //     phoneExtensionCode: '91',
            //     phoneNumber: [123456789, [Validators.required]],
            //     email: ['', [Validators.required, Validators.email]],
            //     message: ['', [Validators.required]]
            // })
        });
    }

    get passengers() {
        return this.contactForm.get('passengers') as FormArray;
    }

    addPassenger(tt: string, i: number, lead = 0) {
        this.passengers.push(this.createPassenger(tt, i, lead));
    }

    createPassenger(tt: string, i: number, lead = 0): FormGroup {
        const title = tt == 'infants' ? 'Miss' : 'Mr';
        const paxType = tt == 'adults' ? 1 : (tt == 'infants' ? 3 : 2);
        return this.fb.group(
            {
                IsLeadPax: lead,
                Title: [title, [Validators.required]],
                FirstName: ['', [Validators.required]],
                MiddleName: '',
                LastName: ['', [Validators.required]],
                PaxType: paxType,
                Gender: '',
                DateOfBirth: ['', [Validators.required]],
                PassportNumber: ['', [Validators.required]],
                PassportExpiry: ['', [Validators.required]],
                PassportIssuingCountry: ['BD', [Validators.required]],
                CountryCode: '',
                CountryName: '',
                ContactNo: '',
                PhoneAreaCode: '',
                PhoneExtensionCode: '',
                City: '',
                PinCode: '',
                AddressLine1: '',
                AddressLine2: '',
                Email: '',
                travellerType: tt,
                travellerTypeCount: i + 1,
                BaggageId: [],
                MealId: [],
                SeatId: []
            }
        );
    }

    onUpdatePassenges(phonecode: any) {
        phonecode = phonecode.split(/[()]/)[1];
        const result = this.phoneCodes.find(c => c.phone_code == phonecode);
        this.passengers.value.forEach((e, i) => {
            this.contactForm.controls['passengers']['controls'][i].patchValue({
                CountryCode: result.phone_code,
                CountryName: result.name
            });
        });
    }

    onSubmitBooking() {
        if (!this.terms) {
            return;
        }
        let baggageProtection = this.contactForm.value.baggageProtection;
        if (this.flight['Attr']['is_usa']) {
            this.contactForm.patchValue({ usaForm: 0 });
        } else {
            this.contactForm.patchValue({ usaForm: 1 });
        }
        const passengers = this.passengers.value;
        const cEmail = this.contactForm.get('contact.email').value;
        const cPhoneAreaCode = this.contactForm.get('contact.phoneAreaCode').value;
        const cPhoneExtensionCode = this.contactForm.get('contact.phoneExtensionCode').value;
        const cphoneNumber = this.contactForm.get('contact.phoneNumber').value;
        const passportCountryName = this.contactForm.get('contact.countryCode').value;

        const passengersTemp = passengers.map(p => {
            const DateOfBirth = "1994-01-01";
            const PassportExpiry = "2023-01-01";
            const Email = cEmail;
            const PhoneAreaCode = cPhoneAreaCode;
            const PhoneExtensionCode = cPhoneExtensionCode;
            const ContactNo = cphoneNumber;
            const CountryName = passportCountryName;
            let usaFormDetail = {};
            if (this.flight['Attr']['is_usa']) {
                Object.assign(usaFormDetail, {
                    City: this.contactForm.get('usaDetailsForm.city').value,
                    State: this.contactForm.get('usaDetailsForm.state').value,
                    CountryName: this.contactForm.get('usaDetailsForm.country_name').value,
                    CountryCode: 'BD',
                    AddressLine1: this.contactForm.get('usaDetailsForm.address').value,
                    AddressLine2: '.',
                    PinCode: this.contactForm.get('usaDetailsForm.postal_code').value,
                    Gender: this.contactForm.get('usaDetailsForm.gender').value,
                    LocationType: this.contactForm.get('usaDetailsForm.types').value
                });

            }
            return { ...p, DateOfBirth, PassportExpiry, Email, PhoneAreaCode, PhoneExtensionCode, ContactNo, CountryName, ...usaFormDetail };
        });
        this.flightService.loading.next(true);
        if (this.flightService.isDevelopment) {
        } else {
            if (baggageProtection) {
                this.subs.sink = this.apiHandlerService.apiHandler('servicePurchase', 'post', {}, {}, {
                    app_reference: this.flightService.appReference,
                    booking_source: this.flight.booking_source
                }).subscribe(resp => {
                    if (resp.statusCode == 200 || resp.statusCode == 201) {
                    }
                });
            }
            const created_by_id = this.utility.readStorage('b2cUser', sessionStorage)['id'];
            let data = {
                UserId: created_by_id,
                AppReference: this.flightService.appReference,
                BookingSource: this.flight.booking_source,
                // AppReference: this.flightService.resultToken,
                SequenceNumber: 0,
                ResultToken: this.flightService.resultToken,
                Passengers: passengersTemp
            }
            console.log(passengersTemp);

            this.subs.sink = this.apiHandlerService.apiHandler('commitBooking', 'POST', '', '', {
                UserId: created_by_id,
                AppReference: this.flightService.appReference,
                booking_source: this.flight.booking_source,
                BookingSource: "B2C",
                // AppReference: this.flightService.resultToken,
                SequenceNumber: 0,
                ResultToken: this.flightService.resultToken,
                Passengers: passengersTemp,
                Remark:"nosafer B2C"
            }).subscribe(res => {
                if (res.Status) {
                    const BookingDetails = res.data.CommitBooking.BookingDetails;
                    this.flightService.CommitBookingResponse.next(BookingDetails);
                    this.router.navigate(['/flight/confirm-passenger']);
                } else {
                    this.swalService.alert.oops(res.Message);
                    setTimeout(() => {
                        this.router.navigate(['/flight/result']);
                    }, 100);
                }
                this.flightService.loading.next(false);
            });
        }
    }

    getBaggageProtection(val) {
        this.flightService.isBaggeProtected.next(val)
    }

    addYearsToDate(y: number) {
        const d = new Date();
        const year = d.getFullYear();
        const month = d.getMonth();
        const day = d.getDate();
        const c = new Date(year + y, month, day);
        return c;
    }

    onContinue() {
        this.router.navigate(['/flight/guest-details']);
    }

    searcAgain() {
        this.router.navigate(['/flight-result']);
    }

    getBaggage(val: any) {
        if (val) {
            let bg = val.split(" ");
            if (bg.length > 1 && bg[1] != "undefined" && parseInt(bg[0]) > 0)
                return bg[0] + ' ' + ((bg[1] == 'Kilograms' || bg[1] == 'Kg') ? 'KG' : bg[1]);
            else
                return bg[0] + ' ' + 'KG';
        } else if (val === '') {
            return '0 KG';
        }
    }

    getTime(date: any) {
        return date.substr(11, 5);
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

}